import * as React from 'react';

import Box from '@mui/material/Box';

export default function Rotation(){
    return (
        <Box className='wrapper rotation'>
            <h2 className='section-title'>Experience Diverse Rotational Opportunities</h2>
            <Box className="flow-chart">
                <Box className="total">2 Years</Box>
                <Box className="rotation-wrapper">
                    <Box className="rotation-item">
                        <p className="desc">Onboarding</p>
                    </Box>
                    <Box className="rotation-item">
                        <p className="desc">Rotation 1 (6 Months)</p>
                    </Box>
                    <Box className="rotation-item">
                        <p className="desc">Rotation 2 (6 Months)</p>
                    </Box>
                    <Box className="rotation-item">
                        <p className="desc">Rotation 3 (6 Months)</p>
                    </Box>
                    <Box className="rotation-item">
                        <p className="desc">Rotation 4 (6 Months)</p>
                    </Box>
                    <Box className="rotation-item">
                        <p className="desc">Completion & Permanent Placement</p>
                    </Box>
                </Box>
            </Box>
            <p className="desc">These rotations are designed to enhance your technical knowledge and sharpen your business acumen:</p>
            <Box className="item">
                <h4 className="title">Accounting & Financial Reporting</h4>
                <Box className="desc">
                    Prepare accurate and timely quarterly and annual group reports and financial statements, offering comprehensive insights into the company's financial performance.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Business Assurance</h4>
                <Box className="desc">
                    Drive efficiency and effectiveness in governance, risk management, and internal controls while managing risk and compliance with integrity through continuous improvement.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Business Planning & Analysis</h4>
                <Box className="desc">
                    Participate in the management reporting process, budgeting, and forecasting cycles, and perform key analyses on the financial performance of business segments at regional level.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Controllership</h4>
                <Box className="desc">
                    Collaborate with country finance and business teams to spearhead pivotal projects and new developments, enhancing financial processes and reporting quality across the group, and driving strategic insights.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Corporate Treasury</h4>
                <Box className="desc">
                    Engage in managing the liquidity for Sea's businesses, supporting the company's long-term strategy and growth opportunities.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Finance Business Analytics</h4>
                <Box className="desc">
                    Enhance finance operations by optimizing reporting metrics and frameworks through technology, leveraging data analytics to gain strategic financial insights.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Finance Process & Systems Innovation</h4>
                <Box className="desc">
                    Pioneer transformative initiatives to achieve finance excellence by adopting technology and automation, enhancing efficiency and productivity.
                </Box>
            </Box>
            <Box className="item">
                <h4 className="title">Regional Tax</h4>
                <Box className="desc">
                    Optimize tax strategies and ensure compliance with tax regulations, contributing to the company's overall financial efficiency.
                </Box>
            </Box>




            
        </Box>
    );
}